//#region src/core/i18n/text/buttons.ts
const prefix = "buttons.";
const playText = {
	key: `${prefix}play`,
	text: "Play"
};
const pauseText = {
	key: `${prefix}pause`,
	text: "Pause"
};
const replayText = {
	key: `${prefix}replay`,
	text: "Replay"
};
const muteText = {
	key: `${prefix}mute`,
	text: "Mute"
};
const unmuteText = {
	key: `${prefix}unmute`,
	text: "Unmute"
};
//#endregion
export { muteText, pauseText, playText, replayText, unmuteText };

//# sourceMappingURL=buttons.js.map